<template>
    <div class="promo-projects-section" v-if="indexPage != null">
        <div class="container">
            <div class="section-title-new">
                <h2>{{ indexPage.our_project_section_title }}</h2>
                <router-link to="/projects" class="link-icon" @click.native="startLoader" v-if="!isMobileChecker">
                    <span>{{ indexPage.our_project_projects_btn }}</span>
                    <svgIcon name="arrow-go-right"/>
                </router-link>
            </div>
            <div class="projects-cards-promo" v-if="dataArr != null">
                <div class="card" v-for="item in dataArr">
                    <router-link :to="{ name : 'project-card' , params:{id : item.slug }}" class="link-to-page" @click.native="startLoader">
                        <div class="card-img" :style="'background-image: url(' + item.acf.project_img + ');'"></div>
                        <div class="card-desc">
                            <p>{{ item.acf.project_name }}</p>
                            <div class="btn-go">
                                <svgIcon name="arrow-go-right"/>
                            </div>
                        </div>
                    </router-link>
                </div>
            </div>
            <router-link to="/projects" class="link-icon-mobile" @click.native="startLoader" v-if="isMobileChecker">
                <span>{{ indexPage.our_project_projects_btn }}</span>
                <svgIcon name="arrow-go-right"/>
            </router-link>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex'
    import svgIcon from '@/components/partials/SvgIcon.vue';
    export default {
        name: 'sales-about-projects',
        components: {
            svgIcon,
        },
        data () {
            return {
                initVideo: false,
                dataArr: null,
            }
        },
        computed: mapGetters({
            indexPage: 'loadIndexPage',
            isMobileChecker: 'loadIsMobileChecker',
        }),
        methods: {
            getProjectItems() {
                if (this.indexPage != null) {
                    const data = this.indexPage.our_project_project_objects;
                    var id_str = '';
                    for (var i=0; i<data.length; i++) {
                        id_str = id_str + data[i].project.ID
                    }
                    var correct_str = id_str.match(/.{1,4}/g);
                    var id_s = correct_str.join(",");
                    axios.get(window.url + window.GlobalLang + '/wp-json/wp/v2/projects_complete?include=' + id_s).then(async (response) => {
                        // console.log(response, 'object ITEMs');
                        this.dataArr = response.data;
                    });
                }
            },
            startLoader() {
                this.$parent.$parent.$refs.topProgress.start();
            },
        },
        beforeCreate() {
        },
        created () {
        },
        mounted() {
            this.getProjectItems();
            this.$store.watch(
                (state) => state.indexPage,
                (newValue) => {
                    if (newValue) 
                    this.getProjectItems();
                }
            );
            this.$store.watch(
                (state) => state.projectItemsDefault,
                (newValue) => {
                    if (newValue) 
                    this.getProjectItems();
                }
            );
        }
    }
</script>

<style lang="scss">
    @import '@/styles/components/index-promo/promo-projects.scss';
    @import '@/styles/respond/index-promo/respond-promo-projects.scss';
    // @import '@/styles/respond/index-promo/respond-promo-fine-finish.scss';
</style>